// extracted by mini-css-extract-plugin
export default {"modal":"RecievedPackageOps_modal__GI2aC","modal-bg":"RecievedPackageOps_modal-bg__7J-EY"};